import type { IconProps } from "../../src/types";
import { splitProps } from "solid-js";

function renderSvg(kebab: string, props: IconProps) {
  const [local, rest] = splitProps(props, ["class", "size", "color", "strokeWidth"]);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={local.size ?? 24}
      height={local.size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      stroke={local.color ?? "currentColor"}
      stroke-width={local.strokeWidth ?? 2}
      stroke-linecap="round"
      stroke-linejoin="round"
      class={local.class ? `lucide lucide-${kebab} ${local.class}` : `lucide lucide-${kebab}`}
      aria-hidden={rest["aria-label"] || rest.title ? undefined : "true"}
      {...rest}
    >
      <circle cx="12" cy="12" r="10" />
      <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
      <path d="M12 17h.01" />
    </svg>
  );
}

export const CircleHelp = (props: IconProps) => renderSvg("circle-help", props);
export const CircleQuestionMark = (props: IconProps) => renderSvg("circle-question-mark", props);
export const HelpCircle = (props: IconProps) => renderSvg("help-circle", props);
export const CircleHelpIcon = CircleHelp;
export const CircleQuestionMarkIcon = CircleQuestionMark;
export const HelpCircleIcon = HelpCircle;
export default CircleHelp;
